
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ProgramsCTASection() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      const response = await fetch('https://readdy.ai/api/forms/program-updates', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          email: email
        })
      });

      if (response.ok) {
        setIsSubmitted(true);
        setEmail('');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <section className="py-16 bg-blue-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Advance Your Career?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Join thousands of healthcare professionals who are advancing their careers through CPVA's comprehensive programs and educational opportunities.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-800 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-graduation-cap-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Expert-Led Education</h3>
              <p className="text-blue-200">Learn from industry leaders and subject matter experts</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-800 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Networking Opportunities</h3>
              <p className="text-blue-200">Connect with peers and build professional relationships</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-800 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Continuing Education</h3>
              <p className="text-blue-200">Earn credits and maintain professional certifications</p>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Stay Updated on New Programs
            </h3>
            <p className="text-gray-600 mb-6">
              Be the first to know about new educational opportunities, events, and program launches.
            </p>
            
            {isSubmitted ? (
              <div className="text-center py-4">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-2xl text-green-600"></i>
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">Thank You!</h4>
                <p className="text-gray-600">You've been successfully subscribed to program updates.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4" data-readdy-form id="program-updates">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  className="flex-1 px-4 py-3 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
                <Button type="submit" size="lg" className="whitespace-nowrap">
                  Get Updates
                </Button>
              </form>
            )}
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <Button size="lg" className="bg-white text-blue-900 hover:bg-gray-100">
              Browse All Programs
            </Button>
            <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-blue-900">
              Become a Member
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
